import { cn } from '../../styles/lib/utils';

type PagePickerDotsProps = {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  className?: string;
  /** When set, each dot button receives this value with the zero-based page index applied. */
  dotDataTestId?: (pageIndex: number) => string;
  'data-testid'?: string;
};

function PagePickerDots({
  totalPages,
  currentPage,
  onPageChange,
  className,
  dotDataTestId,
  'data-testid': dataTestId,
}: PagePickerDotsProps) {
  return (
    <div data-slot="page-picker-dots" data-testid={dataTestId} className={cn('flex items-center h-3.5', className)}>
      {Array.from({ length: totalPages }, (_, idx) => {
        const key = `dot-${totalPages}-${idx}`;
        return (
          <button
            type="button"
            key={key}
            onClick={() => onPageChange(idx)}
            aria-label={`Go to page ${idx + 1}`}
            aria-current={idx === currentPage ? 'step' : undefined}
            data-testid={dotDataTestId?.(idx)}
            className={cn('flex cursor-pointer items-center justify-center w-3.5 h-3.5 rounded-full focus-ring')}
          >
            <span
              className={cn(
                'block rounded-full transition-all duration-200',
                idx === currentPage ? 'h-2.5 w-2.5 bg-primary' : 'h-1.5 w-1.5 bg-grey-30',
              )}
            />
          </button>
        );
      })}
    </div>
  );
}

export { PagePickerDots, type PagePickerDotsProps };
